import { Controller } from '@hotwired/stimulus'
import Plyr from 'plyr'
import '../../src/css/modules/plyr.scss'

export default class extends Controller {
  static targets = [ 'plyrInstance' ]

  // connect works for elements added to the DOM
  connect() {
    // multiple Plyr initialization
    // this.players = Plyr.setup('.js-plyr-player')
    // TODO: initiate start play (but not in all situations)
    // TODO: stop other instances of player on the same page

    // if page displayed from cache or
    // we see its from cache because plyr markup was added
    // then no need to instantiate plyr
    if (!(document.documentElement.hasAttribute("data-turbo-preview") || this.plyrInstanceTarget.classList.contains('plyr'))) {
      this.player = new Plyr(this.plyrInstanceTarget)
    }
  }

  // action from turbo event
  // it's possible to use disconnect()
  // but youtube throw warnings
  destroyPlyrInstance() {
    if (this.player) this.player.destroy()
  }
}
